import QRCode from 'react-qr-code';
import AccentureLogo from '../resources/images/AccentureLogo';
import HeaderBackground from '../resources/images/HeaderBackground.png';
import HeaderBackground2 from '../resources/images/HeaderBackground2.png';
import { useRecoilState } from 'recoil';
import { agentState } from '../recoil';

interface HeaderProps {
  qrCodeURL: string;
}

function VoiceItineraryHeader({ qrCodeURL }: HeaderProps) {
  const [currentAgent, setCurrentAgent] = useRecoilState(agentState);

  function isInnovationHubAgent(agent: string) {
    return agent === 'houston' || agent === 'atlanta';
  }

  return (
    <div className="relative mt-2 h-full w-full">
      <div
        className={`Header  flex  w-full  items-end  gap-3  px-4  sm:pb-3.5 sm:pt-3  md:justify-between md:pt-16   `}
      >
        <div className="HeaderLeftSide  flex h-full flex-col items-start justify-center gap-2">
          <div className="Frame18 flex h-5 w-36 items-start justify-start gap-4">
            <div className="AccentureLogo1 relative h-5 w-20">
              <AccentureLogo />
            </div>
          </div>
          <div className="YourItinerary max-w-[367px] font-['Graphik'] text-5xl font-semibold text-white md:text-6xl">
            {isInnovationHubAgent(currentAgent) ? 'Your Demo Picker' : 'Your Itinerary'}
          </div>
        </div>
        <div className="HeaderRightSide hidden max-h-[150px] min-h-36 max-w-[318px]  gap-2.5 rounded-3xl    p-4 backdrop-blur-3xl md:flex">
          <div className="Frame20 flex shrink grow basis-0 flex-col items-center justify-center gap-4">
            <div className="WantToTakeYourItineraryWithYou self-stretch font-['Graphik'] text-base font-semibold leading-tight text-white">
              Want to take your itinerary with you?
            </div>
            <div className="ScanWithYourPhoneToDownload self-stretch font-['Graphik'] text-sm font-normal leading-none text-white">
              Scan with your phone to download
            </div>
          </div>
          <div className="QrCodeExample1 relative h-28 w-28">
            <QRCode
              size={256}
              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              value={qrCodeURL}
              viewBox={`0 0 256 256`}
              bgColor="transparent"
              fgColor="#FFFFFF"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VoiceItineraryHeader;
